import { Comp, NormalizedDataPoint, SheetWithIndexes } from "../PreparedDataset";
import { parseCalendarDate } from "../calendarDate";

export type V2FileData = {
  version: "v2";
  data: SheetWithIndexes;
};

const columnIndexes = {
  address: 0,
  address2: 1,
  date: 2,
  price: 3,
};

export function sheetToFileV2Data(data: SheetWithIndexes): V2FileData {
  return {
    version: "v2",
    data,
  };
}

export function normalizeDataV2(
  data: SheetWithIndexes,
  outliers?: string[],
  comps?: Comp[],
): NormalizedDataPoint[] {
  return data.map((row) => {
    const indexes = columnIndexes;

    const address = row.cells[indexes.address] + " " + row.cells[indexes.address2];
    const date = row.cells[indexes.date];
    const price = row.cells[indexes.price];

    return {
      address,
      date: parseCalendarDate(date),
      dateString: date,
      price: Number(price),
      priceString: price,
      id: row.id,
      outlier: outliers && outliers.includes(row.id),
      comp: comps && comps.map((c) => c.id).includes(row.id),
    };
  });
}
